import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'acs-yes-no-dialog',
  templateUrl: './yes-no-dialog.component.html'
})
export class YesNoDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      content: string;
      confirmText: string;
      denyText: string;
      includeCancel: boolean;
    },
    private dialogRef: MatDialogRef<YesNoDialogComponent>
  ) {}

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
